import { Injectable } from '@angular/core';
import { ForgotPasswordService } from '@epicuro-next/platform/authentication';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { forgotPassword } from '../actions';
import { map, switchMap } from 'rxjs/operators';
import {
  APP_AUTH_LEVEL_PATH,
  APP_TOP_LEVEL_PATH,
} from '@epicuro-next/navigation/constants';
import { go } from '@epicuro-next/state/router-store';

@Injectable()
export class ForgotPasswordEffects {
  constructor(
    private actions$: Actions,
    private forgotPasswordService: ForgotPasswordService,
  ) {}

  public forgotPassword$ = createEffect(() =>
    this.actions$.pipe(
      ofType(forgotPassword),
      switchMap(({ username }) => this.forgotPasswordService.request(username)),
      map(() => {
        return go({
          commands: [
            '/',
            APP_TOP_LEVEL_PATH.authentication.path,
            APP_AUTH_LEVEL_PATH.login.path,
          ],
        });
      }),
    ),
  );
}
